export interface Story {
  id: number;
  title: string;
  summary: string;
  category: string;
  status: string;
  heat: string;
  updatedAt: string;
  tags: string[];
  image: string;
  note: string;
}

export interface TimelineNode {
  time: string;
  title: string;
  desc: string;
  type: '爆料' | '发酵' | '回应' | '反转' | '收尾';
}

export const storyCategories: string[] = [
  '全部',
  '团队声明',
  '直播争议',
  '恋情动态',
  '商务资源',
  '作品争议',
  '社交平台',
];

export const stories: Story[] = [
  {
    id: 1,
    title: '林知夏深夜探班风波后续：工作室首次正面回应，三点说明还原经过',
    summary:
      '从模糊路透图到完整监控片段，这条瓜走了整整五天。工作室用三点说明回应时间线矛盾，爆料方随后删帖，事件进入收尾阶段。',
    category: '团队声明',
    status: '官方回应',
    heat: '98.6万',
    updatedAt: '3分钟前更新',
    tags: ['深夜探班', '时间线矛盾', '第二弹'],
    image:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20scene%20with%20glowing%20stage%20spotlight%20and%20crimson%20haze%2C%20scattered%20paper%20texture%2C%20dramatic%20cinematic%20mood%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=gt-story-01&orientation=landscape',
    note: '信息仍在核实中，请以当事人与官方声明为准',
  },
  {
    id: 2,
    title: '周野直播口误事件第二弹：品牌方连夜撤下宣传物料，本人追加致歉',
    summary:
      '一句口误引发连锁反应，合作品牌连夜下架相关物料。当事人当晚发布第二条致歉视频，并宣布暂停直播一周。',
    category: '直播争议',
    status: '持续发酵',
    heat: '87.3万',
    updatedAt: '12分钟前更新',
    tags: ['口误', '品牌撤物料', '追加致歉'],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20neon%20livestream%20studio%20silhouette%20with%20amber%20and%20red%20light%20streaks%2C%20dark%20stylized%20background%2C%20smoke%20texture%2C%20no%20text%2C%20editorial%20mood&width=800&height=600&seq=gt-story-02&orientation=landscape',
    note: '涉及商业合作，双方均未公布完整合同细节',
  },
  {
    id: 3,
    title: '阿鲤恋情时间线被整理成图，反转出现在第三天凌晨',
    summary:
      '网友自发整理出超长恋情时间线，第三日凌晨出现的反转节点让舆论彻底转向，多个原爆料账号公开更正。',
    category: '恋情动态',
    status: '已反转',
    heat: '76.1万',
    updatedAt: '28分钟前更新',
    tags: ['时间线图', '反转', '当事人发声'],
    image:
      'https://readdy.ai/api/search-image?query=stylized%20romantic%20city%20night%20bokeh%20with%20warm%20amber%20lights%20and%20soft%20crimson%20glow%2C%20abstract%20cinematic%20blur%2C%20no%20text%2C%20elegant%20composition&width=800&height=600&seq=gt-story-03&orientation=landscape',
    note: '恋情属个人隐私，本站仅汇总公开信息',
  },
  {
    id: 4,
    title: '蓝小满合约纠纷新进展：前公司放出沟通记录，双方各执一词',
    summary:
      '解约风波进入第二轮交锋，前公司放出部分沟通记录，艺人方回应称记录被断章取义，双方均表示将走法律程序。',
    category: '商务资源',
    status: '进行中',
    heat: '65.4万',
    updatedAt: '45分钟前更新',
    tags: ['解约', '沟通记录', '法律程序'],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20contract%20documents%20on%20wooden%20desk%20under%20warm%20lamp%20light%2C%20shallow%20depth%20of%20field%2C%20muted%20paper%20tones%20with%20amber%20accent%2C%20no%20readable%20text&width=800&height=600&seq=gt-story-04&orientation=landscape',
    note: '纠纷细节以法院与双方公告为准',
  },
  {
    id: 5,
    title: '沈砚新歌被指旋律相似，制作人回应：采样已获授权',
    summary:
      '新歌上线三天被指前奏相似，制作人晒出授权文件截图并说明采样来源，音乐平台已恢复歌曲正常推荐。',
    category: '作品争议',
    status: '已澄清',
    heat: '58.9万',
    updatedAt: '1小时前更新',
    tags: ['采样', '授权文件', '版权'],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20audio%20waveform%20and%20vinyl%20record%20with%20warm%20amber%20gradient%20light%2C%20dark%20stylized%20studio%20background%2C%20no%20text%2C%20premium%20editorial&width=800&height=600&seq=gt-story-05&orientation=landscape',
    note: '版权判定需专业机构评估，请勿自行定性',
  },
  {
    id: 6,
    title: '玖玖点赞风波升级：小号截图流出，团队称账号被盗',
    summary:
      '一张疑似小号点赞截图在社交平台快速扩散，团队发布安全说明称账号存在异地登录，平台方暂未回应。',
    category: '社交平台',
    status: '进行中',
    heat: '52.2万',
    updatedAt: '2小时前更新',
    tags: ['小号截图', '账号安全', '异地登录'],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20glowing%20smartphone%20screens%20floating%20in%20dark%20space%20with%20crimson%20and%20amber%20light%2C%20digital%20network%20lines%2C%20no%20text%2C%20stylized%20tech%20mood&width=800&height=600&seq=gt-story-06&orientation=landscape',
    note: '截图真伪需平台方可核实',
  },
  {
    id: 7,
    title: '方屿片场路透引争议，剧组发声明强调安全规范',
    summary:
      '一段片场路透视频引发对拍摄安全的讨论，剧组当天发布声明说明防护措施，并要求在场人员停止传播未公开画面。',
    category: '作品争议',
    status: '官方回应',
    heat: '47.8万',
    updatedAt: '3小时前更新',
    tags: ['片场路透', '安全规范', '剧组声明'],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20film%20set%20with%20warm%20spotlights%20and%20smoke%20haze%2C%20silhouettes%20of%20equipment%2C%20cinematic%20amber%20and%20deep%20red%20tones%2C%20no%20text%2C%20moody%20editorial&width=800&height=600&seq=gt-story-07&orientation=landscape',
    note: '未经公开的拍摄画面请勿二次传播',
  },
  {
    id: 8,
    title: '苏栖代言被指撞款，品牌方补齐设计手稿自证时间线',
    summary:
      '新款造型被指与旧作撞款，品牌方公开设计手稿与打样记录，说明创作时间早于争议造型，话题热度逐步回落。',
    category: '商务资源',
    status: '已澄清',
    heat: '41.5万',
    updatedAt: '5小时前更新',
    tags: ['代言', '设计手稿', '撞款'],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20fashion%20sketch%20and%20fabric%20swatches%20on%20cream%20paper%20with%20amber%20warm%20light%2C%20stylized%20flat%20lay%2C%20no%20readable%20text%2C%20refined%20editorial&width=800&height=600&seq=gt-story-08&orientation=landscape',
    note: '设计相似度属主观判断，请理性讨论',
  },
  {
    id: 9,
    title: '闻莺退赛传闻第二弹：节目组回应赛程调整并非退赛',
    summary:
      '缺席录制引发退赛猜测，节目组发布赛程调整说明，当事人转发并附上一句「下周见」，传闻当日基本平息。',
    category: '团队声明',
    status: '官方回应',
    heat: '38.9万',
    updatedAt: '8小时前更新',
    tags: ['退赛传闻', '赛程调整', '下周见'],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20stage%20with%20empty%20microphone%20stand%20and%20warm%20amber%20spotlight%20beam%2C%20deep%20red%20curtain%20blur%2C%20cinematic%20atmosphere%2C%20no%20text&width=800&height=600&seq=gt-story-09&orientation=landscape',
    note: '赛程信息以节目官方公告为准',
  },
];

export const featuredTimeline: TimelineNode[] = [
  {
    time: '09-05 21:40',
    title: '爆料起源',
    desc: '某论坛出现一张模糊路透图，配文只有一句「深夜探班」，词条首次进入热议榜尾部。',
    type: '爆料',
  },
  {
    time: '09-06 08:15',
    title: '话题发酵',
    desc: '多个转发账号在标题上添油加醋，话题在半天内冲到热议榜前三，但原始信源始终没有补充证据。',
    type: '发酵',
  },
  {
    time: '09-06 14:02',
    title: '首次回应',
    desc: '工作室发布简短声明，表示已委托律师对不实信息取证，并提醒网友不要扩散未经核实的画面。',
    type: '回应',
  },
  {
    time: '09-07 10:30',
    title: '关键反转',
    desc: '现场工作人员放出完整监控时间片段，显示当事人进出时间与爆料描述明显矛盾，舆论开始松动。',
    type: '反转',
  },
  {
    time: '09-08 19:20',
    title: '当事人发声',
    desc: '当事人直播澄清当晚行程，逐条回应三个争议点，直播累计观看突破两千万。',
    type: '回应',
  },
  {
    time: '09-09 16:45',
    title: '第二弹更新',
    desc: '最初爆料账号发布道歉长文并删除原帖，承认部分内容系拼接推测，多个转载账号跟进更正。',
    type: '反转',
  },
  {
    time: '09-10 11:00',
    title: '尘埃落定',
    desc: '双方发布联合声明，将事件定性为沟通误会，相关词条从热议榜撤下，全程追踪到此收尾。',
    type: '收尾',
  },
];

export const topicCards = [
  {
    name: '团队声明',
    count: 42,
    icon: 'ri-megaphone-line',
    desc: '工作室、经纪团队的正式声明与澄清原文汇总。',
  },
  {
    name: '直播争议',
    count: 28,
    icon: 'ri-live-line',
    desc: '直播现场的口误、情绪与突发状况，逐帧复盘。',
  },
  {
    name: '恋情动态',
    count: 35,
    icon: 'ri-heart-3-line',
    desc: '时间线、同框与反转节点，只汇总公开信息。',
  },
  {
    name: '商务资源',
    count: 19,
    icon: 'ri-handbag-line',
    desc: '代言、合约与解约风波的进展与官方说明。',
  },
  {
    name: '作品争议',
    count: 23,
    icon: 'ri-film-line',
    desc: '曲目、影视与片场相关争议的来龙去脉。',
  },
  {
    name: '社交平台',
    count: 16,
    icon: 'ri-chat-smile-2-line',
    desc: '点赞、取关、评论截图引发的连锁讨论。',
  },
];